export default function removeProjectIdFromLayerId(layerId) {
  // eslint-disable-next-line no-useless-escape
  return layerId?.replace(/\-\d+$/, '');
}
